import { setExpiredAuth } from '../../../actions/digitalSavings/quote';
import {
    apiTransitionPolicyNumber,
    policyNumberSuccess,
    policyNumberFailure,
    triggerKePaymentsStkPush,
} from '../../../actions/digitalSavings/payment';
import { getAccessToken, getIsPolicyNumberAPiPending, } from '../../../selectors/digitalSavings/payment';
import axios from 'axios';

export const policyNumberService = (store, next, action) => {
    (async () => {
        if (!getIsPolicyNumberAPiPending(store.getState())) {
            store.dispatch(apiTransitionPolicyNumber.pending());
            try {
                const resp = await policyNumber(store.getState());
                store.dispatch(policyNumberSuccess(resp.data));
                store.dispatch(apiTransitionPolicyNumber.success());
                store.dispatch(triggerKePaymentsStkPush());
            } catch (e) {
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                store.dispatch(apiTransitionPolicyNumber.failure());
                store.dispatch(policyNumberFailure(e));
            }
        }
    })();
    return next(action);
};

const policyNumber = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/digital-savings/policy-number';
        const response = await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
        return response;
    } catch (e) {
        if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
            store.dispatch(setExpiredAuth(true));
        }
        throw e;
    }
};
